import { Stack } from "@mui/material";
import amlImage from "@repo/ui/assets/images/water_colour_credit-rgb.png";
import { FC, useEffect } from "react";
import { useTypedTranslation } from "../../hooks";
import { DefaultStepProps } from "../Stepper/CustomStepper";
import { BodyTextM, HeadingM } from "../Typography";
import * as Styled from "./AMLIdentificationIntroPage.styled";
import { ChangePensionContributionStepExtraProps } from "./ChangePensionContribution.types";

type AMLIdentificationPageProps = DefaultStepProps & ChangePensionContributionStepExtraProps;

export const AMLIdentificationIntroPage: FC<AMLIdentificationPageProps> = ({
    setModalTitle,
    setNextButtonComponent,
}) => {
    const { t } = useTypedTranslation();

    // Set custom title just for this step
    useEffect(() => {
        setModalTitle?.(t("AML.amlQuestionaire.title"));
        return () => {
            // Reset title back to default on unmount
            setModalTitle?.(null);
        };
    }, [setModalTitle, t]);

    // reset next button to default (just for sure)
    useEffect(() => {
        setNextButtonComponent?.(null);
    }, [setNextButtonComponent]);

    return (
        <Styled.ContainerStack>
            <Stack>
                <HeadingM>{t("AML.amlReasoning.greeting")}</HeadingM>
                <BodyTextM>{t("AML.amlReasoning.insurancePayout")}</BodyTextM>
            </Stack>
            <Styled.AmlImage src={amlImage} alt="AML" />
        </Styled.ContainerStack>
    );
};
